import { useTracksBuffer } from "@/services/buffer-controller";
import { Computed, observer } from "@legendapp/state/react";
import { TrackSnapshot } from "./track-snapshot";
import { hiddenTracks$ } from "../state";

export const Tracks = observer(() => {
  const [tracksBuffer] = useTracksBuffer();
  const tracks = tracksBuffer.getTracks();
  const filteredTracks = hiddenTracks$.get();

  return (
    <Computed>
      {() =>
        tracks.map((track) =>
          !filteredTracks.has(track) ? (
            <TrackSnapshot key={track} trackId={track} />
          ) : null
        )
      }
    </Computed>
  );
});
